import { useEffect, useRef } from 'react';

export const useTouchGestures = (containerRef, { zoom, setZoom, pan, setPan }) => {
  const touchStartRef = useRef({ x: 0, y: 0 });
  const lastPanRef = useRef({ x: 0, y: 0 });
  const touchStartDistRef = useRef(0);
  const touchStartZoomRef = useRef(zoom);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleTouchStart = (e) => {
      if (e.touches.length === 1) {
        // Single touch: prepare for panning
        touchStartRef.current = {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
        };
        lastPanRef.current = { ...pan };
      } else if (e.touches.length === 2) {
        // Two fingers: prepare for pinch zoom
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        const dist = Math.hypot(
          touch2.clientX - touch1.clientX,
          touch2.clientY - touch1.clientY
        );
        touchStartDistRef.current = dist;
        touchStartZoomRef.current = zoom;
      }
    };

    const handleTouchMove = (e) => {
      if (e.touches.length === 1) {
        // Single touch: pan
        const dx = e.touches[0].clientX - touchStartRef.current.x;
        const dy = e.touches[0].clientY - touchStartRef.current.y;
        setPan({
          x: lastPanRef.current.x + dx,
          y: lastPanRef.current.y + dy,
        });
      } else if (e.touches.length === 2) {
        // Two fingers: pinch zoom
        e.preventDefault();
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        const dist = Math.hypot(
          touch2.clientX - touch1.clientX,
          touch2.clientY - touch1.clientY
        );

        const ratio = dist / touchStartDistRef.current;
        const newZoom = Math.max(0.25, Math.min(3, touchStartZoomRef.current * ratio));
        setZoom(newZoom);
      }
    };

    const handleTouchEnd = () => {
      // Reset on touch end
    };

    container.addEventListener('touchstart', handleTouchStart, { passive: true });
    container.addEventListener('touchmove', handleTouchMove, { passive: false });
    container.addEventListener('touchend', handleTouchEnd);

    return () => {
      container.removeEventListener('touchstart', handleTouchStart);
      container.removeEventListener('touchmove', handleTouchMove);
      container.removeEventListener('touchend', handleTouchEnd);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoom, pan, setZoom, setPan]);
};
